(function($) {
    $(function() {

        var titre = $('#js--titre_evenement');
        var champTitre = $('#js--valeur-titre')
		
		if(titre.length){
			var titre_provenance = titre.text();
			champTitre.val(titre_provenance);
		}

    });
})(jQuery);
